/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

// import Timer from "./subcomponents/Timer";
import CountDown from "./subcomponents/CountDown";
import SectionThree from "./subcomponents/SectionThree";
import SectionOne from "./subcomponents/SectionOne";
import SectionTwo from "./subcomponents/SectionTwo";

const useStyles = makeStyles((theme) => ({
  timerBoi: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 5rem)",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      height: "calc(100vh - 1em)",
    },
  },
}));

const EdenComingSoon = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.timerBoi}>
        {/* <Timer /> */}
        <SectionOne />
        <CountDown
          endDate={props.liveIn ? props.liveIn : "December 01, 2021 00:00:00"}
        />
        <SectionTwo />
        <SectionThree />
      </div>
    </React.Fragment>
  );
};

export default EdenComingSoon;
